module.exports = __webpack_public_path__ + "static/media/contracts.4bfdf43a.svg";